import { render, staticRenderFns } from "./DomainClassDetail.vue?vue&type=template&id=25970850"
import script from "./DomainClassDetail.vue?vue&type=script&lang=js"
export * from "./DomainClassDetail.vue?vue&type=script&lang=js"
import style0 from "./DomainClassDetail.vue?vue&type=style&index=0&id=25970850&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports